import $ from 'jquery';
import 'jquery-ujs';
import moment from 'moment';
import 'rails.validations';

import ShowablePassword from 'components/showable_password';
import Topbar from 'components/topbar';
import SkipAutoPayment from 'components/upcoming_payments';

import GearsPopoverInitializer from 'components/gears_popover_initializer';
import HelpBubbleAccessibilityHandler from 'components/help_bubble_accessibility_handler';
import LegalDocumentHandler from 'components/legal_document_handler';
import Revealer from 'components/revealer';
import MobileAppInitializer from 'components/mobile_app';

new GearsPopoverInitializer(document);
new HelpBubbleAccessibilityHandler(document);
new LegalDocumentHandler();
new Revealer(document);
new MobileAppInitializer();

$(function enableBootstrapTooltips() {
  const selector = $('[data-toggle="tooltip"]');

  if (selector.length > 0) selector.tooltip();
});

$(function enableBootstrapPopovers() {
  const selector = $('[data-toggle="popover"]');

  if (selector.length > 0) selector.popover();
});

window.$ = $;
window.moment = moment;
window.SkipAutoPayment = SkipAutoPayment;
window.ShowablePassword = ShowablePassword;
window.Topbar = Topbar;
